module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1049-4a98c7cd051c346c5775b30d89990e17.png";